import { AlunoContrato } from "./alunoContrato";
import { AlunosTurma } from './alunos-turma';
import { AtividadeAluno } from './atividade-aluno';
import { BeneficioSocialPessoaFisica } from './beneficio-social-pessoa-fisica';
import { EncaminhamentoAluno } from './encaminhamento-aluno';
import { EntidadesSociais } from "./entidades-sociais";
import { Familiares } from './familiares';
import { MatriculaSecretaria } from "./matricula-secretaria";
import { MotivoDesligamento } from './motivo-desligamento';
import { NiveisTurmas } from './niveis-turmas';
import { PessoaFisica } from './pessoa-fisica';
import { Programa } from './programa';
import { Projeto } from './projeto';
import { ResponsaveisAluno } from './responsaveis-aluno';
import { TiposPublicoPrioritario } from './tipos-publico-prioritario';
import { Unidade } from './unidade';
import { UniformeAluno } from './uniforme-aluno';
import { VulnerabilidadesAluno } from './vulnerabilidades-aluno';


export class Aluno {
	id: number;
	descProblemaSaude: string;
	descMedicamentosControlados: string;
	descFormaIngressoEntidade: string;
	descricaoEscolaImportacao: string;
	descricaoSerieImportacao: string;
	atendidoOrgaoRede: string;
	observacoes: string;
	
	dataEncaminhamento: Date;
	dataEntrada: Date;
	dataDesligamento: Date;
	dataCadastro: Date;
	dataAlteracaoCadastro: Date;
	descDesligamento: string;

    entidadeSocial: EntidadesSociais;
    matriculaSecretaria: MatriculaSecretaria;
    pessoaFisica: PessoaFisica;
	unidade: Unidade;
	
	moraPais: boolean;
	paisCasados: boolean;
	descBuscaEscola: string;
	publicoPrioritario: string;
	matriculaAluno: string;
	nivelTurma: NiveisTurmas;

	vulnerabilidades: VulnerabilidadesAluno[];
	encaminhamentos: EncaminhamentoAluno[];
	benefeciosSociaisPessoaFisica: BeneficioSocialPessoaFisica[];

	tiposPublicoPrioritario:TiposPublicoPrioritario;
	motivoDesligamento:MotivoDesligamento;

	dataSugestaoDesligamento:Date;
	descricaoSugestaoDesligamento:String;
	programa: Programa;
	projeto: Projeto;
	
	observacaoDeclaracaoPasse: string;
	dataDeclaracaoPasse: Date;
	observacaoDeclaracaoMatricula: string;
	dataDeclaracaoMatricula: Date;
	participaApresentacaoExterna: boolean;

	stAtivo: boolean;

	nome?: string;
	nomeMae?: string;
	cpf?: string;

	//Utilizado para a aba de familiar no cadastro de aluno, é o responsavel vigente
	familiar: Familiares;
	responsavelVigente: ResponsaveisAluno;
	
	atividades: AtividadeAluno[];

	matriculas: AlunosTurma[];

	alunosContrato: AlunoContrato[];

	uniformes: UniformeAluno[];
	tiposPublicosPrioritarios: TiposPublicoPrioritario[];
	turmaSecretaria: string;
}